import {InvalidUrl} from '@freckle/student-entities/ts/common/exceptions/invalid-url'

export function extractNumberFromParams(
  params: Inexact<{
    [x: string]: string | undefined | null
  }>,
  param: string
): number {
  const number = parseInt(extractFromParams(params, param), 10)
  if (isNaN(number)) {
    throw new InvalidUrl({message: `URL param ${param} is not a number`})
  }

  return number
}

export function extractFromParams(
  params: Inexact<{
    [x: string]: string | undefined | null
  }>,
  param: string
): string {
  const mValue = params[param]

  if (mValue === null || mValue === undefined) {
    throw new InvalidUrl({message: `Cannot find ${param} in URL`})
  }

  return mValue
}

export function extractNumberArrayParams(
  params: Inexact<{
    [x: string]: string | undefined | null
  }>,
  param: string
): Array<number> {
  const assignmentStr = extractFromParams(params, param)
  return assignmentStr.split(',').map(str => {
    const number = parseInt(str, 10)
    if (isNaN(number)) {
      throw new InvalidUrl({message: `URL param ${param} is not a number`})
    }

    return number
  })
}
